<div class="flex-row-start">
  <img class="promotion__image flex flex-50" src="/assets/images/promotions/{{ imageName }}.png">
  <div class="flex-50">
    <ng-content></ng-content>
    <app-contact-us displayStyle="button" label="Contact us for more information" instructions="This notifications-only user has requested that they be contacted while viewing a promotions page about the full version of GPS." [interaction]="false"></app-contact-us>
  </div>
</div>
